import React from "react";
import { Course } from "../../compilers/course";
import { Chapter } from "../../compilers/chapter";
import { useTranslation } from "react-i18next";
import ShareButtons from "../singlecomponents/ShareButtons";
import Button from "../../components/singlecomponents/Button";
import CourseChapter from "./CourseChapter";
import { ReactComponent as ChevronRight } from "../../assets/chevron-right.svg";
import { ReactComponent as ChevronLeft } from "../../assets/chevron-left.svg";
import "../../stylesheet/components/media/MediaBody.scss";
import Skeleton from "react-loading-skeleton";

type CourseBodyProps = {
  course: Course;
  currentChapterIndex: number;
  nextChapter: () => void;
  previousChapter: () => void;
  setCurrentChapter: (index: number) => void;
  returnToSummary: () => void;
};

const CourseBody: React.FC<CourseBodyProps> = ({
  course,
  currentChapterIndex,
  nextChapter,
  previousChapter,
  setCurrentChapter,
  returnToSummary
}) => {
  const { t, i18n, ready } = useTranslation();
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const getHeroImage = () => {
    if (course.data.heroImage && currentChapterIndex === 1) {
      return (
        <img
          src={course.data.heroImage}
          className="media-hero-image mb-3"
          alt=""
        />
      );
    }
  };

  const getCurrentChapter = () => {
    return course.data.body.find(
      (chapter: Chapter) => chapter.index === currentChapterIndex
    );
  };

  return (
    <div className="media-body">
      {getHeroImage()}
      <CourseChapter
        returnToSummary={returnToSummary}
        setCurrentChapter={setCurrentChapter}
        currentChapterIndex={currentChapterIndex}
        course={course}
        chapter={getCurrentChapter()}
      />
      <div className="d-flex justify-content-between my-3 px-lg-4">
        <button
          className={`p2 btn btn-second prev-btn ${
            currentChapterIndex === 0 ? "faint-yellow" : ""
          }`}
          disabled={currentChapterIndex === 1}
          onClick={() => {
            scrollToTop();
            previousChapter();
          }}
        >
          <span>
            <ChevronLeft
              className="chevron"
              style={
                i18n.language == "ar"
                  ? { transform: `rotate(180deg)` }
                  : { transform: `rotate(0deg)` }
              }
            />
            &nbsp;&nbsp;&nbsp;{" "}
            {ready ? `${t("button.prev")}` : <Skeleton width={80} />}
          </span>
        </button>
        <button
          className={`p2 btn btn-second next-btn ${
            currentChapterIndex === course.data.body.length
              ? "faint-yellow"
              : ""
          }`}
          disabled={currentChapterIndex === course.data.body.length}
          onClick={() => {
            scrollToTop();
            nextChapter();
          }}
        >
          <span>
            {ready ? `${t("button.next")}` : <Skeleton width={80} />}
            &nbsp;&nbsp;&nbsp;{" "}
            <ChevronRight
              style={
                i18n.language == "ar"
                  ? { transform: `rotate(180deg)` }
                  : { transform: `rotate(0deg)` }
              }
              className="chevron"
            />
          </span>
        </button>
      </div>
      <div className="media-back-and-share course-inner">
        <div className="back-btn w-100" onClick={returnToSummary}>
          <Button
            bootstrapClass="px-sm-2 px-md-4 py-1"
            name={t("button.back-course")}
          />
        </div>
        <ShareButtons />
      </div>
    </div>
  );
};

export default CourseBody;
